/* Converting the API model object from www.telenor.no/system/channels/help/ to same format as listTvChannels */
export default (obj) => {
	if (obj.displayName) obj.name = obj.displayName;
	if (obj.features && obj.features.length > 0) {
		if (obj.features[0].constructor === Object) {
			obj = remodelFeatureList(obj);
		} else {
			obj.feature = obj.features;
		}
	}
	return obj;

	function remodelFeatureList(value) {
		let feature = [];
		let availableFeatures = [
			{
				trigger: "catchupTV",
				translation: "Ukesarkiv",
			},
			{
				trigger: "startOver",
				translation: "Start forfra",
			},
		];

		value.features.forEach((f) => {
			if (f.key === "channelPosition") {
				value.position = "Kanalposisjon: " + f.value;
				value.sortPosition = f.value;
			} else if (f.key === "language") value.language = "Språk: " + f.value;
			else if (findIfAvailableFeature(f).valid) feature.push(findIfAvailableFeature(f).value);
			else if (f.value === "true") feature.push(f.key);
			else feature.push(f.value);
		});
		value.feature = feature;
		value.missingFeature = availableFeatures
			.filter((availf) => {
				if (feature.indexOf(availf.translation) === -1) return availf;
			})
			.map((f) => {
				return f.translation;
			});
		return value;

		function findIfAvailableFeature(currentf) {
			let found = availableFeatures.filter(function (availf) {
				if (availf.trigger === currentf.key) return availf;
			});
			if (found.length > 0) {
				return {
					valid: true,
					value: found[0].translation,
				};
			}
			return {
				valid: false,
			};
		}
	}
};
